module.exports = __webpack_public_path__ + "img/u_brackets-curly.110b123e.svg";